import { useApplyReceiptItemDiscount } from '@/api/receipt/use-apply-receipt-item-discount.ts';
import type { ReceiptItemDto } from '@/api/types';
import { Button } from '@/components/ui/button.tsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.tsx';
import { formatPrice } from '@/helpers/formatters.ts';

type ReceiptDiscountRowProps = {
  discount: ReceiptItemDto;
  items: ReceiptItemDto[];
};

const ReceiptDiscountRow = ({ discount, items }: ReceiptDiscountRowProps) => {
  const { mutateAsync: applyDiscount } = useApplyReceiptItemDiscount();

  const handleItemClick = (item: ReceiptItemDto) => {
    applyDiscount({ receiptItemId: item.uuid, discountId: discount.uuid }).catch(() => undefined);
  };

  return (
    <div className="border rounded-lg p-2">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
        <div className="flex items-start justify-between gap-2 sm:contents">
          <div className="text-sm font-medium sm:order-1 sm:w-1/2 sm:grow-0">
            {discount.name || 'Discount'}
          </div>
          <div className="text-lg font-semibold text-right text-red-600 sm:order-3 sm:mt-1 sm:w-24">
            {formatPrice(discount.amount)}
          </div>
        </div>
        <div className="sm:order-2 sm:w-1/2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" className="w-full justify-start text-muted-foreground">
                Select item to apply discount
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="max-w-[calc(100vw-2rem)]">
              {items.map((item) => (
                <DropdownMenuItem key={item.uuid} onClick={() => handleItemClick(item)}>
                  <div className="flex items-center justify-between gap-2 w-full">
                    <span>
                      {item.quantity}x {item.name}
                    </span>
                    <span className="font-semibold">{formatPrice(item.amount)}</span>
                  </div>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </div>
  );
};

export default ReceiptDiscountRow;
